import { getValue } from 'shop-packages/redux/connectSelector';
import { selectCurrentDeliveryOptionId, selectDeliveryOptions } from 'shop-packages/redux/checkout/selectors';

export const getDeliveryOptionType = () => {
  const optionsId = getValue(selectCurrentDeliveryOptionId);
  const deliveryOptions = getValue(selectDeliveryOptions);

  const type = deliveryOptions.find(({ pk }) => pk === optionsId)?.delivery_option_type;

  return type;
}